window.personalExhibitionRow = function() {
    return {
      fields: [],
      initialize(data){
        for (let i = 0; i < data.length; i++) {
            this.fields.push({
                personal_exhibition_year: data[i].year,
                personal_exhibition_text: data[i].title
            });
        }

        Sortable.create(document.getElementById('personal_exhibition_sortable'), {
            animation: 150,
            handle: ".my-handle",
        });
      },
      addNewRow() {
            this.fields.push({
                personal_exhibition_year: '',
                personal_exhibition_text: ''
            });
        },
        removeRow(index) {
           this.fields.splice(index, 1);
         }
      }
 }

 window.groupExhibitionRow = function() {
    return {
      fields: [],
      initialize(data){
        for (let i = 0; i < data.length; i++) {
            this.fields.push({
                group_exhibition_year: data[i].year,
                group_exhibition_text: data[i].title
            });
        }

        Sortable.create(document.getElementById('group_exhibition_sortable'), {
            animation: 150,
            handle: ".my-handle",
        });
      },
      addNewRow() {
            this.fields.push({
                group_exhibition_year: '',
                group_exhibition_text: ''
            });
        },
        removeRow(index) {
           this.fields.splice(index, 1);
         }
      }
 }

 window.awardRow = function() {
    return {
      fields: [],
      initialize(data){
        for (let i = 0; i < data.length; i++) {
            this.fields.push({
                award_year: data[i].year,
                award_text: data[i].title
            });
        }

        Sortable.create(document.getElementById('award_sortable'), {
            animation: 150,
            handle: ".my-handle",
        });
      },
      addNewRow() {
            this.fields.push({
                award_year: '',
                award_text: ''
            });
        },
        removeRow(index) {
           this.fields.splice(index, 1);
         }
      }
 }